import React from 'react'

export default () => (
  <svg
    width="23"
    height="23"
    viewBox="0 0 23 23"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g stroke="#454545" fill="none" fillRule="evenodd">
      <path d="M12.014 2H2.91C1.894 2 1 2.822 1 3.836v15.786c0 1.014.895 1.91 1.91 1.91h15.786c1.014 0 1.835-.896 1.835-1.91v-9.105M14.95 1h5.14C21.106 1 22 1.895 22 2.91v5.14M13.74 9.26l7.457-7.457" />
    </g>
  </svg>
)



// WEBPACK FOOTER //
// ./src/icons/shareIcon.js